import React from "react";
import { Navigate, Outlet, useLocation } from "react-router-dom";

type Props = {
    allowedRoles?: string[]; // hvis tom/undefined = alle loggede ind må
};

const PrivateRoute: React.FC<Props> = ({ allowedRoles }) => {
    const location = useLocation();
    const token = sessionStorage.getItem("authToken");

    if (!token) {
        return <Navigate to="/login" replace state={{ from: location }} />;
    }

    // Hvis der er rollekrav:
    if (allowedRoles && allowedRoles.length > 0) {
        const roles: string[] = JSON.parse(sessionStorage.getItem("userRoles") || "[]");
        const isAllowed = roles.includes("Admin") || allowedRoles.some((r) => roles.includes(r));

        if (!isAllowed) {
            return <Navigate to="/unauthorized" replace state={{ from: location.pathname }} />;
        }
    }

    return <Outlet />;
};

export default PrivateRoute;
